// URI
export const BASE_URL = process.env.REACT_APP_BACK_URI + 'api/v1/';

//STATUS
export const STATUS_URL = process.env.REACT_APP_BACK_URI + 'status';

// INFO
export const INFO_URL = process.env.REACT_APP_BACK_URI + 'info/';

// BASE
export const BASE_USER_URI = BASE_URL + 'usuarios/';
export const BASE_OAUTH_URI = BASE_URL + 'auth/';
export const BASE_NOTIFICACOES_URI = BASE_URL + 'notificacoes/';
export const BASE_POSICOES_URI = BASE_URL + 'posicoes/';
export const BASE_RELATORIOS_URI = BASE_URL + 'relatorios/';
export const BASE_ENTIDADES_URI = BASE_URL + 'entidades/';
export const BASE_CONVITES_URI = BASE_URL + 'convites/';
export const BASE_CARTEIRAS_URI = BASE_URL + 'carteiras/';
export const BASE_INDICADORES_URI = BASE_URL + 'indicadores/';
export const BASE_CONSULTAS_URI = BASE_URL + 'consultas/';
export const BASE_OUTPUTS_URI = BASE_URL + 'outputs/';
export const BASE_ATIVOSBASE_URI = BASE_URL + 'ativosbase/';
export const BASE_ATIVOS_URI = BASE_URL + 'ativos/';
export const BASE_PESSOAS_URI = BASE_URL + 'pessoas/';
export const BASE_SETORES_URI = BASE_URL + 'setores/';
export const BASE_PESQUISA_URI = BASE_URL + 'pesquisas/';
export const BASE_CENARIOS_URI = BASE_URL + 'cenarios/';
export const BASE_BENCHMARKS_URI = BASE_URL + 'benchmarks/';
export const BASE_METRICAS_URI = BASE_URL + 'metricas/';
export const BASE_CONFERENCIASCUSTODIANTES_URI = BASE_URL + 'conferenciascustodiantes/';

// Autenticação
export const OAUTH_VERIFY_USERNAME = BASE_OAUTH_URI;
export const OAUTH_UPDATE_TOKEN = BASE_OAUTH_URI;
export const OAUTH_LOGIN = BASE_OAUTH_URI;
export const OAUTH_LOGOUT = BASE_OAUTH_URI;
export const OAUTH_REGISTER = BASE_OAUTH_URI + 'register/';
export const OAUTH_REGISTER_CODE_VALIDATE = OAUTH_REGISTER;
export const OAUTH_PASSWORD_RESET = BASE_OAUTH_URI + 'password/';
export const OAUTH_PASSWORD_RESET_VALIDATE = OAUTH_PASSWORD_RESET;
export const OAUTH_PASSWORD_RESET_CONFIRM = OAUTH_PASSWORD_RESET;

// User
export const USER_READ = BASE_USER_URI;
export const USER_READ_USERNAME = BASE_USER_URI;
export const USER_UPDATE = BASE_USER_URI;
export const USER_UPDATE_PASSWORD = BASE_USER_URI + 'password/';
export const USER_FAVORITE_LIST = BASE_USER_URI + 'favoritos/';
export const USER_FAVORITE_UPDATE = BASE_USER_URI;
export const USER_SUMMARY_LIST = BASE_USER_URI + 'resumos/';
export const USER_SUMMARY_UPDATE = BASE_USER_URI;

// Notificações
export const NOTIFICACAO_LIST = BASE_NOTIFICACOES_URI;
export const NOTIFICACAO_RESPONDER = BASE_NOTIFICACOES_URI;

// Posicoes
export const POSICOES_UPLOAD_LIST = BASE_POSICOES_URI + 'upload/';
export const POSICOES_UPLOAD = BASE_POSICOES_URI + 'upload/';
export const POSICOES_UPLOAD_DELETE = BASE_POSICOES_URI + 'upload/';
export const POSICOES_DOWNLOAD = BASE_POSICOES_URI + 'download/';
export const POSICOES_DELETE = BASE_POSICOES_URI;
export const POSICOES_DELETE_DATA = BASE_POSICOES_URI;
export const POSICOES_LIST = BASE_POSICOES_URI;
export const POSICOES_ADD = BASE_POSICOES_URI;
export const POSICOES_DATAS = BASE_POSICOES_URI + 'datas/';
export const POSICOES_COPY = BASE_POSICOES_URI + 'copiar/';
export const POSICOES_OPEN = BASE_POSICOES_URI + 'abrir/';
export const POSICOES_FECHADA_LIST = BASE_POSICOES_URI + 'fechadas/';
export const POSICOES_FECHADA_ADD = BASE_POSICOES_URI + 'fechadas/';
export const POSICOES_FECHADA_DELETE = BASE_POSICOES_URI + 'fechadas/';
export const POSICOES_ABERTA = BASE_POSICOES_URI + 'aberta/';
export const POSICOES_ABERTA_RESUMO = BASE_POSICOES_URI + 'aberta/resumo';
export const POSICOES_ABERTA_PENDENCIA = BASE_POSICOES_URI + 'aberta/pendencia';
export const POSICOES_ULTIMA = BASE_POSICOES_URI + 'ultima/';

// Conferencia Custodiante
export const CONFERENCIACUSTODIANTE_DATAS = BASE_CONFERENCIASCUSTODIANTES_URI + 'datas/';
export const CONFERENCIACUSTODIANTE_ATIVOS = BASE_CONFERENCIASCUSTODIANTES_URI + 'ativos/';
export const CONFERENCIACUSTODIANTE_IGNORADA_LIST =
  BASE_CONFERENCIASCUSTODIANTES_URI + 'ignoradas/';
export const CONFERENCIACUSTODIANTE_IGNORADA_ADD = BASE_CONFERENCIASCUSTODIANTES_URI + 'ignoradas/';
export const CONFERENCIACUSTODIANTE_IGNORADA_DELETE =
  BASE_CONFERENCIASCUSTODIANTES_URI + 'ignoradas/';
export const CONFERENCIACUSTODIANTE_DELETE = BASE_CONFERENCIASCUSTODIANTES_URI;

// Relatórios
export const RELATORIOS_CREATE = BASE_RELATORIOS_URI;

// Entidades
export const ENTIDADES_LIST = BASE_ENTIDADES_URI;
export const ENTIDADES_UPDATE = BASE_ENTIDADES_URI;
export const ENTIDADES_DELETE = BASE_ENTIDADES_URI;
export const ENTIDADES_MODIFY = BASE_ENTIDADES_URI;
export const ENTIDADES_ADD = BASE_ENTIDADES_URI;
export const ENTIDADES_PL = BASE_ENTIDADES_URI + 'pl/';
export const ENTIDADES_PL_ADD = ENTIDADES_PL;
export const ENTIDADES_PL_LIST = ENTIDADES_PL;
export const ENTIDADES_PL_REMOVE = ENTIDADES_PL;
export const ENTIDADES_PL_MODIFY = ENTIDADES_PL;
export const ENTIDADES_USUARIO_ADD = BASE_ENTIDADES_URI + 'usuario/';
export const ENTIDADES_USUARIO_LIST = BASE_ENTIDADES_URI + 'usuario/';
export const ENTIDADES_USUARIO_REMOVE = BASE_ENTIDADES_URI + 'usuario/';
export const ENTIDADES_USUARIO_MODIFY = BASE_ENTIDADES_URI + 'usuario/';
export const ENTIDADES_IFEED_LOGO = BASE_ENTIDADES_URI + 'ifeed/logo/';
export const ENTIDADES_ENQUADRAMENTOS = BASE_ENTIDADES_URI + 'enquadramentos/';
export const ENTIDADES_ENQUADRAMENTOS_ADD = ENTIDADES_ENQUADRAMENTOS;
export const ENTIDADES_ENQUADRAMENTOS_MODIFY = ENTIDADES_ENQUADRAMENTOS;
export const ENTIDADES_ENQUADRAMENTOS_REMOVE = ENTIDADES_ENQUADRAMENTOS;
export const ENTIDADES_ENQUADRAMENTOS_COPY = ENTIDADES_ENQUADRAMENTOS + 'copiar/';
export const ENTIDADES_ENQUADRAMENTOS_REGRAS = ENTIDADES_ENQUADRAMENTOS + 'regras/';
export const ENTIDADES_ENQUADRAMENTOS_PADRAO = ENTIDADES_ENQUADRAMENTOS + 'padrao/';
export const ENTIDADES_ENQUADRAMENTOS_REGRAS_LIST = ENTIDADES_ENQUADRAMENTOS_REGRAS;
export const ENTIDADES_ENQUADRAMENTOS_REGRAS_ADD = ENTIDADES_ENQUADRAMENTOS_REGRAS;
export const ENTIDADES_ENQUADRAMENTOS_REGRAS_MODIFY = ENTIDADES_ENQUADRAMENTOS_REGRAS;
export const ENTIDADES_ENQUADRAMENTOS_REGRAS_REMOVE = ENTIDADES_ENQUADRAMENTOS_REGRAS;
export const ENTIDADES_ENQUADRAMENTOS_REGRAS_SYS = ENTIDADES_ENQUADRAMENTOS_REGRAS + 'enum';

// Convites
export const CONVITES_CONVIDAR = BASE_CONVITES_URI;

// Carteiras
export const CARTEIRAS_LIST = BASE_CARTEIRAS_URI;
export const CARTEIRAS_FAV = BASE_CARTEIRAS_URI;
export const CARTEIRAS_DELETE = BASE_CARTEIRAS_URI;
export const CARTEIRAS_CREATE = BASE_CARTEIRAS_URI;
export const CARTEIRAS_READ = BASE_CARTEIRAS_URI;
export const CARTEIRAS_PL = BASE_CARTEIRAS_URI + 'pl/';
export const CARTEIRAS_PL_ADD = CARTEIRAS_PL;
export const CARTEIRAS_PL_LIST = CARTEIRAS_PL;
export const CARTEIRAS_PL_REMOVE = CARTEIRAS_PL;
export const CARTEIRAS_PL_MODIFY = CARTEIRAS_PL;

// Indicadores
export const INDICADORES_LIST = BASE_INDICADORES_URI;
export const INDICADORES_COTACAO = BASE_INDICADORES_URI + 'cotacao';

// Consultas
export const CONSULTAS_INDICADORES = BASE_CONSULTAS_URI + 'indicadores/';
export const CONSULTAS_INDICADORES_VARIACAO = CONSULTAS_INDICADORES + 'variacao/';
export const CONSULTAS_ATIVOS = BASE_CONSULTAS_URI + 'ativos/';
export const CONSULTAS_ATIVOS_VARIACAO = CONSULTAS_ATIVOS + 'variacao/';
export const CONSULTAS_CORRELACAO = BASE_CONSULTAS_URI + 'correlacao/';
export const CONSULTAS_CORRELACAO_BENCHMARK = BASE_CONSULTAS_URI + 'correlacaobm/';

// Outputs
export const OUTPUTS_LOGS = BASE_OUTPUTS_URI + 'logs/';
export const OUTPUTS_LOGS_DELETE = OUTPUTS_LOGS;
export const OUTPUTS_DURATION = BASE_OUTPUTS_URI + 'duration/';
export const OUTPUTS_ENQUADRAMENTO = BASE_OUTPUTS_URI + 'enquadramento/';
export const OUTPUTS_VAR = BASE_OUTPUTS_URI + 'var/';
export const OUTPUTS_STRESSTEST = BASE_OUTPUTS_URI + 'stresstest/';
export const OUTPUTS_CONFERENCIACUSTODIANTE = BASE_OUTPUTS_URI + 'conferenciacustodiante/';
export const OUTPUTS_DOWNLOAD = BASE_OUTPUTS_URI + 'download/';
export const OUTPUTS_PREVIEW = BASE_OUTPUTS_URI + 'preview/';
export const OUTPUTS_CACHE = BASE_OUTPUTS_URI + 'cache/';
export const OUTPUTS_ENUM = BASE_OUTPUTS_URI + 'enum/';
export const OUTPUTS_CACHE_DOWNLOAD = OUTPUTS_CACHE + 'download/';
export const OUTPUTS_CACHE_LIST = OUTPUTS_CACHE + 'list/';
export const OUTPUTS_CACHE_DELETE = OUTPUTS_CACHE;

// Ativos Base
export const ATIVOSBASE_LIST = BASE_ATIVOSBASE_URI;
export const ATIVOSBASE_MERCADO = BASE_ATIVOSBASE_URI + 'mercados';
export const ATIVOSBASE_COTACAO = BASE_ATIVOSBASE_URI + 'cotacao';
export const ATIVOSBASE_READ = BASE_ATIVOSBASE_URI;
export const ATIVOSBASE_CURVA = BASE_ATIVOSBASE_URI + 'curva';

// Ativos
export const ATIVOS_LIST = BASE_ATIVOS_URI;
export const ATIVOS_MERCADO = BASE_ATIVOS_URI + 'mercados';
export const ATIVOS_TIPOS = BASE_ATIVOS_URI + 'tipos';
export const ATIVOS_COTACAO = BASE_ATIVOS_URI + 'cotacao';
export const ATIVOS_CURVA = BASE_ATIVOS_URI + 'curva';

// Pessoas
export const PESSOAS_LIST = BASE_PESSOAS_URI;
export const PESSOAS_BALANCO = BASE_PESSOAS_URI + 'balanco';
export const PESSOAS_BALANCO_RESUMO = BASE_PESSOAS_URI + 'balanco/disponivel';
export const PESSOAS_BALANCO_CONTAS = BASE_PESSOAS_URI + 'balanco/contas';
export const PESSOAS_BALANCO_SALDOS = BASE_PESSOAS_URI + 'balanco/saldos';
export const PESSOAS_PL = BASE_PESSOAS_URI + 'pl';
export const PESSOAS_CS = BASE_PESSOAS_URI + 'cs';
export const PESSOAS_ATIVOS = BASE_PESSOAS_URI + 'ativos';
export const PESSOAS_SETORES = BASE_PESSOAS_URI + 'setores';
export const PESSOAS_PERFIL = BASE_PESSOAS_URI + 'perfil';
export const PESSOAS_PATROCINADORES = BASE_PESSOAS_URI + 'patrocinadores';

// Setores
export const SETORES_LIST = BASE_SETORES_URI;
export const SETORES_READ = BASE_SETORES_URI;

// Pesquisa
export const PESQUISA_PRINCIPAL = BASE_PESQUISA_URI + 'principal';
export const PESQUISA_CORRELACAO = BASE_PESQUISA_URI + 'correlacao';
export const PESQUISA_ATIVO = BASE_PESQUISA_URI + 'ativo';
export const PESQUISA_INDICADOR = BASE_PESQUISA_URI + 'indicador';
export const PESQUISA_PESSOA = BASE_PESQUISA_URI + 'pessoa';

// CENARIOS
export const CENARIOS_ADD = BASE_CENARIOS_URI;
export const CENARIOS_LIST = BASE_CENARIOS_URI;
export const CENARIOS_REMOVE = BASE_CENARIOS_URI;
export const CENARIOS_MODIFY = BASE_CENARIOS_URI;

// BENCHMARKS
export const BENCHMARKS_ADD = BASE_BENCHMARKS_URI;
export const BENCHMARKS_LIST = BASE_BENCHMARKS_URI;
export const BENCHMARKS_REMOVE = BASE_BENCHMARKS_URI;
export const BENCHMARKS_MODIFY = BASE_BENCHMARKS_URI;

// METRICAS
export const METRICAS_PESSOA = BASE_METRICAS_URI + 'pessoa';
export const METRICAS_PESSOAS = BASE_METRICAS_URI + 'pessoas';
